const cancelHover = "hover:bg-blue-600 hover:text-white";
const submitHover = "hover:bg-blue-600";
const fieldStyles = "shadow-sm appearance-none border rounded w-full py-2 px-3 text-gray-800";
const buttonStyles = "bg-blue-500 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline";
const cancelStyles = "text-blue-800 font-bold mr-4 py-2 px-4 rounded focus:outline-none focus:shadow-outline";
const buttonDisabled = "opacity-50";

export { cancelHover, fieldStyles, buttonStyles, cancelStyles, buttonDisabled, submitHover };
